import Vue from 'vue'

import { ValidationProvider, ValidationObserver, extend, setInteractionMode, configure } from 'vee-validate';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

setInteractionMode('eager');

import { i18n } from "../i18n";

configure({
    defaultMessage: (field, values) => {
        values._field_ = i18n.t(`vee_validate.fields.${field}`);
        if(i18n.te(`vee_validate.custom.${field}.${values._rule_}`)){
            return i18n.t(`vee_validate.custom.${field}.${values._rule_}`, values);
        } else {
            return i18n.t(`vee_validate.validation.${values._rule_}`, values);
        }
    }
});

require('./rules')
